module.exports = __webpack_public_path__ + "media/paliwa/pb_95@3x-103e0ab7.svg";